const hasNumericValue = (value) => (
  value !== null &&
  value !== "" &&
  typeof value !== "undefined" &&
  !Number.isNaN(Number(value))
);

export const cloneOptions = (options) => JSON.parse(JSON.stringify(options || []));

export const getOptionUnitPrice = (option) => {
  if (option && hasNumericValue(option.addPrice)) return Number(option.addPrice);
  if (option && hasNumericValue(option.price)) return Number(option.price);
  return 0;
};

export const getOptionTotalPrice = (option) => (
  getOptionUnitPrice(option) * (option && option.qty ? Number(option.qty) : 1)
);
